import React from "react";
import "../../assets/styles/components/select.scss";

interface Props {
  title?: string;
  className?: string;
  option: {
    value: string;
    name: string;
  }[];
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const Select: React.FC<Props> = ({
  onChange,
  option,
  title,
  className,
  value,
}) => {
  let attributes = Object.assign({});
  attributes.className = `select-row ${className || ""}`;
  return (
    <div {...attributes} style={{
      display: 'flex',
      alignItems: 'center',
      padding: '0.5rem 1rem'
    }}>
      <div className="title-input">{title}</div>

      <select
        name="cars"
        id="cars"
        onChange={onChange}
        value={value}
        className=""
      >
        {option.map((option, index) => (
          <option value={option.value} key={index}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
};
export default Select;
